import { createUseStyles } from 'react-jss';

const styles = {
  button: {
    width: '50%',
    minWidth: 'auto',
  },
  buttonsWrapper: {
    marginTop: '5rem',
    display: 'flex',
    gap: '1.6rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
